const TechnologyPost = [
    {
      id:1,
      img:"https://ichef.bbci.co.uk/news/976/cpsprodpb/13B2F/production/_127678608_gettyimages-1244636244.jpg.webp",
      title:"Is this really the end of Twitter?",
      details: "Twitter today is awash with people saying goodbye. The hashtag 'RIPTwitter' is trending and lots of the site's users are scrambling to download their data.",
      date:"Nov 12, 2022",
      type:"Technology"
    },
    {
      id:2,
      img:"https://images.news18.com/ibnlive/uploads/2022/11/redmi-pad-16684932063x2.jpg?impolicy=website&width=510&height=356",
      title:"Redmi Tablet Budget is Worth Buying",
      details: "Budget tablets have grown, and they are quite likeable now. After using the new tablets in the market, we had set our expectations for the Redmi Pad, and thankfully it came through nicely.",
      date:"Nov 12, 2022",
      type:"Technology"
      
    },
    {
        id:3,
        img:"https://images.news18.com/ibnlive/uploads/2022/09/feature-image-7-1-16639333723x2.jpg?impolicy=website&width=510&height=356",
        title:"Apple will Continue To Use Qualcomm’s",
        details:"Qualcomm will remain the primary supplier of 5G modems for the upcoming iPhones for at least two more years, a top executive has said. ",
        date:"Nov 12, 2022",
        type:"Technology"
    },
    {
        id:4,
        img:"https://images.news18.com/ibnlive/uploads/2022/08/netflix-16609056293x2.png?impolicy=website&width=510&height=356",
        title:"Google Nest Speakers Not Linking With Netflix",
        details: "Netflix integration with Google products and the Google Home app is largely broken right now, the media reported. ",
        date:"Nov 12, 2022",
        type:"Technology",
        num:1
    }    
  ]
  export default TechnologyPost;

export const TechnologyFirstPost = [
{
  id:1,
  img:"https://ichef.bbci.co.uk/news/976/cpsprodpb/7517/production/_124057992_gettyimages-1239414349.jpg",
  title:"Elon Musk firing more employee ",
  date:"Nov 13, 2022",
  type:"Technology",
  num:"1"
}
]
export const TechnologyTopPost = [
  {
    id:1,
    img:"https://images.news18.com/ibnlive/uploads/2022/10/untitled-design-2022-10-27t170131.369-16668703753x2.jpg?impolicy=website&width=510&height=356",
    title:"The Stuff of Greatness",
    date:"Nov 13, 2022",
    type:"Technology",
    num:"2"
  },
  {
    id:2,
    img:"https://ichef.bbci.co.uk/news/976/cpsprodpb/E690/production/_127642095_ftxgettyimages-1440504577.jpg.webp",
    title:"Failed crypto exchange",
    date:"Nov 13, 2022",
    type:"Technology",
    num:"3"
  },
  {
    id:3,
    img:"https://ichef.bbci.co.uk/news/976/cpsprodpb/6539/production/_127431952_hi079886996.jpg.webp",
    title:"Staff work long or leave",
    date:"Nov 12, 2022",
    type:"Technology",
    num:"4"
  },
  {
    id:4,
    img:"https://images.news18.com/ibnlive/uploads/2022/05/xbox-stream-device-16521098883x2.jpg?impolicy=website&width=510&height=356",
    title:"Xbox Account Suspended",
    date:"Nov 12, 2022",
    type:"Technology",
    num:"5"
  }
  ]